import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO/SEO";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";

const CareersPage: React.FC = () => {
  return (
    <Fragment>
      <SEO title="Careers" description="Join the AXOIX team at Axoix Technologies Private Limited. We're building the future of AI-powered business management." path="/careers" />
      <div className="careers-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="Careers" pagesub="Careers" />

            {/* Not Hiring Section */}
            <section
              style={{
                padding: "80px 0 40px",
                textAlign: "center",
              }}
            >
              <div className="container">
                <div
                  style={{
                    maxWidth: 720,
                    margin: "0 auto",
                    padding: "50px 40px",
                    borderRadius: 16,
                    background: "rgba(15, 20, 40, 0.6)",
                    border: "1px solid rgba(255,255,255,0.08)",
                  }}
                >
                  <div
                    style={{
                      width: 80,
                      height: 80,
                      borderRadius: "50%",
                      background: "rgba(var(--color-primary-rgb, 99,102,241), 0.1)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 30px",
                      fontSize: 36,
                    }}
                  >
                    <i className="fa fa-briefcase" style={{ color: "var(--color-primary)" }} />
                  </div>
                  <h2 style={{ fontSize: 32, marginBottom: 16 }}>
                    We're Not Hiring Right Now
                  </h2>
                  <p
                    style={{
                      fontSize: 17,
                      opacity: 0.75,
                      lineHeight: 1.7,
                      maxWidth: 560,
                      margin: "0 auto",
                    }}
                  >
                    AXOIX is a lean, focused team. We don't have open positions at the
                    moment, but that could change as we grow. Check back here for updates.
                  </p>
                </div>
              </div>
            </section>

            {/* Partner Program CTA */}
            <section
              style={{
                padding: "40px 0 100px",
              }}
            >
              <div className="container">
                <div
                  style={{
                    maxWidth: 720,
                    margin: "0 auto",
                    padding: "50px 40px",
                    borderRadius: 16,
                    background:
                      "linear-gradient(135deg, rgba(var(--color-primary-rgb, 99,102,241), 0.12) 0%, rgba(var(--color-primary-rgb, 99,102,241), 0.04) 100%)",
                    border: "1px solid rgba(var(--color-primary-rgb, 99,102,241), 0.2)",
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      width: 80,
                      height: 80,
                      borderRadius: "50%",
                      background: "rgba(var(--color-primary-rgb, 99,102,241), 0.15)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 30px",
                      fontSize: 36,
                    }}
                  >
                    <i className="fa fa-handshake-o" style={{ color: "var(--color-primary)" }} />
                  </div>
                  <h2 style={{ fontSize: 28, marginBottom: 16 }}>
                    Want to Work With Us? Join as a Partner.
                  </h2>
                  <p
                    style={{
                      fontSize: 17,
                      opacity: 0.75,
                      lineHeight: 1.7,
                      maxWidth: 560,
                      margin: "0 auto 12px",
                    }}
                  >
                    If you're a marketer, agency, freelancer, or consultant — our Partner Program
                    lets you earn <strong style={{ color: "var(--color-primary)", opacity: 1 }}>5-7% recurring commission</strong> on
                    every client you refer to AXOIX, plus multi-level overrides up to 10% total.
                  </p>
                  <p
                    style={{
                      fontSize: 16,
                      opacity: 0.6,
                      lineHeight: 1.7,
                      maxWidth: 560,
                      margin: "0 auto 30px",
                    }}
                  >
                    No employment contract. No minimum commitment. You bring the clients, we handle
                    everything else — onboarding, support, billing. You earn commission for as long
                    as your referral stays subscribed.
                  </p>

                  <div style={{ display: "flex", flexDirection: "column", gap: 20, alignItems: "center" }}>
                    {/* Benefits grid */}
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                        gap: 16,
                        width: "100%",
                        maxWidth: 560,
                        marginBottom: 10,
                        textAlign: "left",
                      }}
                    >
                      {[
                        { icon: "fa-percent", text: "5-7% direct + multi-level overrides" },
                        { icon: "fa-link", text: "Personal referral link & dashboard" },
                        { icon: "fa-calendar-check-o", text: "Monthly payouts via UPI" },
                        { icon: "fa-users", text: "No cap on referrals" },
                      ].map((item, i) => (
                        <div
                          key={i}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 12,
                            padding: "12px 16px",
                            borderRadius: 10,
                            background: "rgba(15, 20, 40, 0.6)",
                            border: "1px solid rgba(255,255,255,0.06)",
                          }}
                        >
                          <i
                            className={`fa ${item.icon}`}
                            style={{ color: "var(--color-primary)", fontSize: 16, width: 20, textAlign: "center" }}
                          />
                          <span style={{ fontSize: 14, opacity: 0.85 }}>{item.text}</span>
                        </div>
                      ))}
                    </div>

                    <Link
                      to="/become-partner"
                      className="btn-primary"
                      style={{
                        display: "inline-block",
                        padding: "14px 40px",
                        borderRadius: 8,
                        background: "var(--color-primary)",
                        color: "#fff",
                        fontWeight: 600,
                        fontSize: 16,
                        textDecoration: "none",
                        transition: "opacity 0.2s",
                      }}
                    >
                      Become a Partner
                    </Link>
                  </div>
                </div>
              </div>
            </section>

            {/* Contact Section */}
            <section
              style={{
                padding: "0 0 80px",
                textAlign: "center",
              }}
            >
              <div className="container">
                <p style={{ fontSize: 15, opacity: 0.5 }}>
                  Have a question about working with AXOIX?{" "}
                  <Link to="/contact" style={{ color: "var(--color-primary)", textDecoration: "underline" }}>
                    Get in touch
                  </Link>
                </p>
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default CareersPage;
